export interface BreadcrumbItem {
  label: string;
  to?: string;
  onClick?: () => void;
}

const APP_TITLE = "Bridge AI Atlas";

const PAGE_LABELS: Record<string, string> = {
  "/": "Dashboard",
  "/contacts": "Contacts",
  "/properties": "Properties",
  "/users": "Users",
  "/branches": "Branches",
  "/legal-entities": "Legal Entities",
  "/leads": "Leads",
  "/campaigns": "Campaigns",
  "/labels": "Labels",
  "/label": "Labels",
  "/diary": "Diary",
  "/documents": "Documents",
  "/images": "Images",
  "/conversations": "Conversations",
  "/client-snapshot": "Client Snapshot",
  "/reach-out": "Reach Out",
  "/integrations": "Integrations",
  "/profile": "Profile",
  "/access-control": "Access Control",
  "/settings": "Settings",
  "/auth": "Authentication",
  "/auth/signup": "Sign Up",
  "/auth/login": "Log In",
};

export function getPageBreadcrumbs(pathname: string, search = ""): BreadcrumbItem[] {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path.startsWith("/integrations/")) {
    const crm = path.split("/")[2] ?? "";
    const formattedCrm = crm
      ? crm.charAt(0).toUpperCase() + crm.slice(1).toLowerCase()
      : "Detail";
    return [
      { label: "Integrations", to: "/integrations" },
      { label: formattedCrm },
    ];
  }
  if (path === "/messages/verifycode") {
    return [{ label: "Integrations", to: "/integrations" }, { label: "Verify Code" }];
  }
  if (path === "/images" || path === "/documents") {
    const params = new URLSearchParams(search);
    const isPropertyContext = params.get("externalPropertyId") ||
      (path === "/images" && params.get("propertyId"));
    if (isPropertyContext) {
      const view = params.get("returnView") === "tile" ? "tile" : "list";
      return [
        { label: "Properties", to: `/properties?view=${view}` },
        { label: PAGE_LABELS[path] },
      ];
    }
  }
  return [{ label: PAGE_LABELS[path] ?? APP_TITLE }];
}

export function formatPageTitle(items: BreadcrumbItem[]): string {
  const label = items.map((item) => item.label).filter(Boolean).join(" / ");
  return label && label !== APP_TITLE ? `${label} | ${APP_TITLE}` : APP_TITLE;
}
